import {randomFromArray} from '../../../helpers/random-from-array.js'
export function getRegularPath(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {

  //strike random enemy opponent
  const aliveTargets = enemyCombatants.filter(combModel => combModel.isAlive());

  if (!aliveTargets.length) {
    console.warn('!!!!!!!!!!!! no alive targets to target..')
    console.warn(enemyCombatants)
    // return null;
  }

  return {
    actionModel: casterActions.find(actionModel => actionModel.id === "attack_generic-attack"),
    casterModel: casterModel,
    targetModels: [ randomFromArray(aliveTargets) ]
  }


}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/personality-paths/get-regular-path.js